import { h, JSX } from 'preact';
import AllMeetingsTable from './allMeetingsTable';import { AllMeetingsPage as FrontEndAllMeetingsPage } from 'core.frontend';
import ObservingComponent from '../componentBases/observingComponent';

export interface AllMeetingsPageProps {
    page: FrontEndAllMeetingsPage;
}

class AllMeetingsPage extends ObservingComponent<AllMeetingsPageProps> {

    public componentWillMount() {
        
    }

    public render({ page }: AllMeetingsPageProps): JSX.Element {
        return (
            <div>
                <div className="page-heading">
                    <h3 className="width-100">
                        <div className="flex">
                            <span className="fill">{page.title}</span>
                        </div>
                    </h3>
                </div>

                <AllMeetingsTable table={page.table} />
            </div>
        );
    
    }
}

export default AllMeetingsPage;
